import { render, staticRenderFns } from "./examination.vue?vue&type=template&id=63dff280&"
import script from "./examination.vue?vue&type=script&lang=js&"
export * from "./examination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports